import { initializeApp } from "firebase/app";
import { getFirestore, doc, getDoc, setDoc, onSnapshot } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCFjPrBGYJWfO109CKdbFgUzbalIss4NNs",
  authDomain: "pritchardwedding-dashboard.firebaseapp.com",
  projectId: "pritchardwedding-dashboard",
  storageBucket: "pritchardwedding-dashboard.firebasestorage.app",
  messagingSenderId: "500305197113",
  appId: "1:500305197113:web:2f05d4348d8dd755ea35e8"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// All wedding data lives in a single Firestore document: weddings/pritchard
const DOC_REF = () => doc(db, "weddings", "pritchard");

// Load all data once on mount
export async function loadAll() {
  try {
    const snap = await getDoc(DOC_REF());
    return snap.exists() ? snap.data() : null;
  } catch (e) {
    console.error("Firebase load error:", e);
    return null;
  }
}

// Save a single key (e.g. "guests", "budget") into the document
export async function saveKey(key, value) {
  try {
    await setDoc(DOC_REF(), { [key]: JSON.stringify(value) }, { merge: true });
  } catch (e) {
    console.error("Firebase save error:", e);
  }
}

// Subscribe to real-time updates — calls onChange(data) whenever partner saves
export function subscribeToChanges(onChange) {
  return onSnapshot(DOC_REF(), (snap) => {
    if (snap.exists()) onChange(snap.data());
  });
}
